export default [
  {
    path: '/privilege/credit/speed',
    name: 'privilegeCreditSpeed',
    component: () => import('@/view/privilege/credit/speed.vue'),
    meta: { pageName: 'page_credit_speed' }
  }, {
    path: '/privilege/credit/speed/rule',
    name: 'privilegeCreditSpeedRule',
    component: () => import('@/view/privilege/credit/speed-rule.vue'),
    meta: { pageName: 'page_credit_speed_rule' }
  }, {
    path: '/privilege/credit/retrial',
    name: 'privilegeCreditRetrial',
    component: () => import('@/view/privilege/credit/retrial.vue'),
    meta: { pageName: 'page_credit_retrial' }
  }, {
    path: '/privilege/credit/retrial/rule',
    name: 'privilegeCreditRetrialRule',
    component: () => import('@/view/privilege/credit/retrial-rule.vue'),
    meta: { pageName: 'page_credit_retrial_rule' }
  }, {
    path: '/privilege/withdraw/retrial',
    name: 'privilegeWithdrawRetrial',
    component: () => import('@/view/privilege/withdraw/retrial.vue'),
    meta: { pageName: 'page_withdraw_retrial' }
  }, {
    path: '/privilege/withdraw/retrial/rule',
    name: 'privilegeWithdrawRetrialRule',
    component: () => import('@/view/privilege/withdraw/retrial-rule.vue'),
    meta: { pageName: 'page_withdraw_retrial_rule' }
  },
  // 授信/拒绝重审卡中间页
  {
    path: '/privilege/middle',
    name: 'privilegeMiddle',
    component: () => import('@/view/privilege/middle.vue')
}]